// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "meal-1-eWm";
var _3 = "meal_aggregation-3pD3y";
export { _1 as "__esModule", _2 as "meal", _3 as "meal_aggregation" }
export default { "__esModule": _1, "meal": _2, "meal_aggregation": _3 }
